import React from 'react';
import { Card, EmptyState } from '../components/ui';

export function ActivityScreen() {
  return (
    <div style={{ padding: 'var(--ozira-space-lg)' }}>
      <Card>
        <EmptyState title="No recent activity" description="Activity across OZIRA products will appear here." />
      </Card>
    </div>
  );
}
